import axios from "axios";
import qs from "qs";
import globalVar from "./globalVar";
import Cookies from "js-cookie";

// import storage from './storage'
const codeMsgCloud = {
  200: "服务器成功返回请求的数据。",
  // 201: '新建或修改数据成功。',
  // 202: '一个请求已经进入后台排队（异步任务）。',
  // 204: '删除数据成功。',
  // 400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  // 401: '用户没有权限（令牌、用户名、密码错误）。',
  // 403: '用户得到授权，但是访问是被禁止的。',
  // 404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  // 406: '请求的格式不可得。',
  // 410: '请求的资源被永久删除，且不会再得到的。',
  // 422: '当创建一个对象时，发生一个验证错误。',
  500: "服务器发生错误，请检查服务器。"
  // 502: '网关错误。',
  // 503: '服务不可用，服务器暂时过载或维护。',
  // 504: '网关超时。',
};

export function httpCloud(url, options, isForm = "urlencoded") {
  // console.log(process.env.NODE_ENV == 'production')
  // console.log('process.env.BASEURL',globalVar.httpType+process.env.BASEURL)



  const HostCloud = (process.env.NODE_ENV === "production" ? '/OnlineCifit':'/OnlineCifit')

      
  console.log("process.env.BASEURL", process.env.NODE_ENV,HostCloud+url);


  //测试服接口
  // const HostCloud =
  //   process.env.NODE_ENV !== "production"
  //     ? globalVar.httpType + "/cloudAPi"
  //     : globalVar.httpType + '//zuul.touzicloud.com';
  // console.log("process.env.BASEURL", process.env.BASEURL);
  // https://zuul.ytz.75z.cn

  // console.log('Host',Host)
  const defaultOptionsCloud = {
    url: HostCloud?(HostCloud+url):url,
    // url:url,
    timeout: 20000
  };

  console.log(defaultOptionsCloud.url)

  const newOptionsCloud = { ...defaultOptionsCloud, ...options };

  newOptionsCloud.headers = {
    token: Cookies.get("token") || "", //这边改变获取token
    // lang:globalVar.ApiLang,
    language: globalVar.lang,
    ...newOptionsCloud.headers
  };

  if (newOptionsCloud.method !== "get") {
    if (isForm == "urlencoded")
      newOptionsCloud.data = qs.stringify(newOptionsCloud.data);
    newOptionsCloud.headers = {
      "Content-Type":
        isForm == "urlencoded"
          ? "application/x-www-form-urlencoded"
          : isForm == "json"
          ? "application/json"
          : "multipart/form-data",
      ...newOptionsCloud.headers
    };
  }

  return (
    axios(newOptionsCloud)
      // .then(checkStatus)
      .then(response => {
        return response.data;
      })
      .catch(function(error) {
        console.warn(error.message);
      })
  );
  // .then(checkCode)
}

export function post(url, data, form = "urlencoded") {

  return httpCloud(url, { method: "post", data }, form);
}

export function get(url, params = {}, testApi = "api") {
  return httpCloud(url, { method: "get", params: params });
}

// function checkStatus(response) {
//   console.log('checkStatus',response)
//   if (response.status >= 200 && response.status < 300) {
//     return response;
//   }
//   const errortext = codeMsg[response.status] || response.statusText
//   console.warn('errortext',errortext)
//   return response
// }

// function checkCode(response){
//   console.log('response',response.data)
//   return response.data
// }



// WEBPACK FOOTER //
// ./src/util/httpCloud3DEH.js